import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, of } from 'rxjs';
import { tap } from 'rxjs/operators';
import { ApiService } from 'src/app/portal-administrador/services/api.service';
import { ExportaDadosViagens, Projeto } from 'src/app/types';
import { environment } from 'src/environments/environment';
import { ApiGraficosService } from './api-graficos.service';

@Injectable({
    providedIn: 'root',
})
export class ApiProjetoService {
    private apiUrl = environment.apiUrl;
    private readonly projetoSubject = new BehaviorSubject<Projeto>(undefined);
    readonly projeto$ = this.projetoSubject.asObservable();

    public exportDataViagem$ = new BehaviorSubject<ExportaDadosViagens[]>(null);

    constructor(
        private http: HttpClient,
        private apiGraficos: ApiGraficosService,
        private apiService: ApiService
    ) {}

    setCurrent(projeto): void {
        this.projetoSubject.next(projeto);
        this.apiGraficos.changeProject(this.getCurrent().id_projeto);
    }

    getCurrent(): Projeto {
        return this.projetoSubject.value;
    }

    getProjeto(id_projeto) {
        return this.http.get<Projeto>(
            `${this.apiUrl}projetos/projetosdadosbasicos/${id_projeto}/?format=json`
        );
    }

    getEquipe() {
        if (this.projetoSubject['equipe']) {
            return of(this.projetoSubject['equipe']);
        } else {
            return this.apiService
                .getEquipe({
                    id_projeto: this.getCurrent().id_projeto,
                })
                .pipe(tap(res => (this.projetoSubject['equipe'] = res)));
        }
    }

    exportData() {
        return this.http.get<Array<any>>(
            `${this.apiUrl}projetos/exportarequipe/${
                this.getCurrent().id_projeto
            }/?format=json`
        );
    }

    async exportDataViagem() {
        if (this.exportDataViagem$.value == null) {
            const ret = await this.http
                .get<ExportaDadosViagens[]>(
                    `${this.apiUrl}suprimentos/exportadadosviagens/${
                        this.getCurrent().id_projeto
                    }/?format=json`
                )
                .toPromise();

            this.exportDataViagem$.next(ret);
        }

        return this.exportDataViagem$;
    }
}
